<template>
    <v-card v-if="event">
        <v-card-title>{{$t('event.details')}}</v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-form ref="form"
                        v-model="isFormValid">
                        <v-row>
                            <v-text-field outlined
                                        :label="$t('event.name')"
                                        :placeholder="$t('event.name')"
                                        v-model="event.name"
                                        :rules="nameRules"></v-text-field>
                        </v-row>
                        <v-row>
                            <v-menu ref="startDateMenu"
                                    v-model="showStartDatePicker"
                                    :close-on-content-click="false"
                                    :return-value.sync="event.start_date"
                                    transition="scale-transition"
                                    offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-text-field outlined
                                                v-model="event.start_date"
                                                :label="$t('event.start_date')"
                                                :placeholder="$t('event.start_date')"
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="event.start_date" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="showStartDatePicker = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.startDateMenu.save(event.start_date)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-row>
                        <v-row>
                            <v-menu ref="endDateMenu"
                                    v-model="showEndDatePicker"
                                    :close-on-content-click="false"
                                    :return-value.sync="event.end_date"
                                    transition="scale-transition"
                                    offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-text-field outlined
                                                v-model="event.end_date"
                                                :label="$t('event.end_date')"
                                                :placeholder="$t('event.end_date')"
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="event.end_date" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="showEndDatePicker = false">{{$t('cancel')}}</v-btn>
                                    <v-btn text color="primary" @click="$refs.endDateMenu.save(event.end_date)">{{$t('ok')}}</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-row>
                        <v-row>
                            <v-select v-show="false"
                                        outlined
                                        :label="$t('event.companyId')"
                                        :placeholder="$t('event.companyId')"
                                        :items="companyOptions"
                                        v-model="event.companyId"
                                        :rules="companyRules"
                                        readonly>
                            </v-select>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-btn color="primary" @click="saveEvent" :disabled="!isFormValid">
                                    {{$t('save')}}
                                </v-btn>
                            </v-col>
                            <v-col>
                                <v-btn color="red" dark @click="deleteEvent">
                                    {{$t('delete')}}
                                </v-btn>
                            </v-col>
                        </v-row>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import {computed, ref, watch} from '@vue/composition-api'
    import {useFind, useGet} from "feathers-vuex";

    export default {
        name: 'EventEdit',
        setup(props, {root}) {
            const {Event, Company} = root.$FeathersVuex.api;

            const eventId = computed(() => root.$route.params.eventId);
            const {item: event, isPending} = useGet({model: Event, id: eventId});

            const nameRules = ref([
                value => !!value || 'Required',
            ]);

            const showStartDatePicker = ref(false);
            const showEndDatePicker = ref(false);

            const eventIdRules = ref([
                value => !!value || 'Required',
            ]);

            const companyParams = computed(() => {
                return {
                    query: {
                        $sort: {
                            name: 1,
                        }
                    }
                }
            });
            const companyData = useFind({model: Company, params: companyParams});
            const companyOptions = computed(() => {
                return companyData.items.value.map(c => {
                    return {text: c.name, value: c.id}
                });
            });
            const companyRules = ref([
                value => !!value || 'Required',
            ]);

            const isFormValid = ref(false);

            const saveEvent = () => {
                event.value.save().then(() => {
                    root.$router.replace({name: 'event-list'});
                }, root.$handleFeatherError.bind(root));
            };

            const deleteEvent = () => {
                if (confirm(root.$t('event.confirm_delete'))) {
                    event.value.remove().then(() => {
                        root.$router.replace({name: 'event-list'});
                    }, root.$handleFeatherError.bind(root));
                }
            };

            return {
                event,
                nameRules,
                showStartDatePicker,
                showEndDatePicker,
                eventIdRules,
                companyOptions,
                companyRules,
                isFormValid,
                saveEvent,
                deleteEvent,
            }
        },
    }
</script>